export default "__VITE_ASSET__YxoRipxq__"